import * as _ from 'lodash';
import 'whatwg-fetch'

interface IRequestInitWithParams extends RequestInit {
  data?: any
  params?: {
    [key: string]: any
  }
}

const defaultRequestInit: IRequestInitWithParams = {
  method: 'GET',
  credentials: 'same-origin'
}

// Must be done to allow for .finally to work on Edge browsers
// see: https://github.com/zloirock/core-js/issues/178#issuecomment-192081350
const fetchPromisfied = (input?: Request | string, requestInit?: IRequestInitWithParams) => {
  const fetchedCall = window.fetch(input, requestInit)

  return Promise.resolve(fetchedCall)
}

/**
 * Wraps fetch calls
 */
export class HttpRequestClass {
  /**
   * Http Request method
   * @param path
   * @param init
   */
  fetch<U>(path: string, init?: IRequestInitWithParams) {
    init = _.extend({}, defaultRequestInit, init)

    if (typeof init.data === 'object') {
      const formData = new FormData()

      Object.keys(init.data).forEach((dataKey) => {
        if (init !== undefined) {
          let dataPiece = init.data[dataKey];

          if (dataPiece === null) {
            dataPiece = '';
          } else if (dataPiece instanceof Blob) {
            // Directly append the Blob or File to FormData
            formData.append(dataKey, dataPiece, 'data.csv');
          } else if (typeof dataPiece === 'object') {
            dataPiece = JSON.stringify(dataPiece);
          }
          formData.append(dataKey, dataPiece)
        }
      })

      init.body = formData
    }

    if (typeof init.params === 'object') {
      const params = init.params

      Object.keys(params).forEach((key, index) => {
        const value = String(params[key])
        path += index === 0 ? '?' : '&'
        path += `${key}=${value}`
      })
    }

    return fetchPromisfied(path, init)
      .then((res) => res.json())
      .then((json: U) => json)
      .catch((error: Response | Error | any) => {
        if (error instanceof Response) {
          return error.json()
            .then((errorRes) => Promise.reject(errorRes))
        } else if (error instanceof Error) {
          if (error.name !== 'AbortError') {
            return Promise.reject(error);
          }
        } else {
          return Promise.reject(JSON.stringify(error));
        }
      })
  }

  /**
   * Http Request method
   * @param path
   * @param init
   */
  fetchBlob<U>(path: string, init?: IRequestInitWithParams) {
    init = _.extend({}, defaultRequestInit, init)

    init['responseType'] = 'arraybuffer'

    if (typeof init.data === 'object') {
      const formData = new FormData()

      Object.keys(init.data).forEach((dataKey) => {
        if (init !== undefined) {
          formData.append(dataKey, init.data[dataKey])
        }
      })

      init.body = formData
    }

    if (typeof init.params === 'object') {
      const params = init.params

      Object.keys(params).forEach((key, index) => {
        const value = String(params[key])
        path += index === 0 ? '?' : '&'
        path += `${key}=${value}`
      })
    }

    return fetchPromisfied(path, init)
      .then((res) => res.blob())
  }
}

export const HttpRequest = new HttpRequestClass()
